import React from "react";

import moment from "moment";

import { withRouter } from "react-router-dom";

import LocationFormat from "../../../../utils/LocationFormat";
import Currency from "../../../../utils/Currency";
import General from "../../../../utils/General";
import Backend from "../../../../utils/Backend";
import Notify from "../../../../utils/Notify";

import BaseTable from "../BaseTable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import { number } from "zod";


const STATUS_FILTERS = {
  name: {
    api: "statuses",
    display: "Status",
  },
  values: [
    {
      label: "All",
      value: null,
    },
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Accepted",
      value: "accepted",
    },
    {
      label: "Looking for Driver",
      value: "looking_for_driver",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
  ],
};

const DATE_FILTERS = {
  name: {
    api: "date_range",
    display: "Date Range",
  },
  values: [
    { label: "Custom", value: "custom" }
  ],
  isDateRange: true
};


const DELIVERY_STATUS_FILTERS = {
  name: {
    api: "delivery_statuses",
    display: "Delivery Status",
  },
  values: [
    {
      label: "All",
      value: null,
    },
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Out For Delivery",
      value: "out_for_delivery",
    },
    {
      label: "Failed",
      value: "failed",
    },
    {
      label: "Returned",
      value: "returned",
    },
    {
      label: "Delivered",
      value: "delivered",
    },
  ],
};

class OrdersHistoryTable extends React.Component {
  // constructor(props) {
  //   super(props);

  //   this.state = {};
  //   this.state = {
  //     ...this.state,
  //     startDate: "",
  //     endDate: "",
  //   };
  //   this.table = React.createRef();
  // }


constructor(props) {
  super(props);

  this.state = {
    startDate: "",
    endDate: "",
    appliedStartDate: "",
    appliedEndDate: "",
    data: [],
    isLoading: false,
  };

  this.table = React.createRef();
}

  // componentWillReceiveProps(nextProps) {
  //   this.setState(nextProps);
  // }

  _renderAddress(address) {
    return <span>{address ? LocationFormat.fullAddress(address) : "-"}</span>;
  }


  _applyDateFilter = () => {
  this.setState(
    {
      appliedStartDate: this.state.startDate,
      appliedEndDate: this.state.endDate,
    },
    () => {
      if (this.table.current && this.table.current.manualReload) {
        this.table.current.manualReload();
      }
    }
  );
};

  exportCSV = () => {
    const rows = this.state.data || [];
    console.log("OrderHistoryTbale exportCSV: ", rows, this.state)
    if (rows.length === 0) return Notify.error("No orders to export");

    const headers = [
      "Order ID,Name,Full Address,Eircode,Mobile,Email,DOB,Product,Category,SubCategory,Vendor,Status,Delivery Status,Total,Driver,Created At"
    ];

    const csvRows = rows.map(order => {

      const address = order.data?.customer_address

      const full_name = order.customer?.user?.first_name + ' ' + order.customer?.user?.last_name; 
      const full_address = address.line_1 + ' ' + address.line_2 + ' ' + address.city + ' ' + address.state; 
      const eircode = address.postal_code || '';
      const mobile = order.customer?.user?.phone_number;
      const email = order.customer?.user?.email;
      const dob = order.customer?.user?.date_of_birth;
      // const product = order.data?.items
      const products = order.data?.items?.map((entry) => {
        const item = entry.item || {};
        const title = item.title || "-";
        return `${title}`;
        }).join(" | ");

      const category = order.data?.items?.map((entry) => {
        const item = entry.item || {};
        const parent = item.subcategory?.parent?.title || "-";
        return `${parent}`;
      }).join(" | ");

      const subCategory = order.data?.items?.map((entry) => {
        const item = entry.item || {};
        const sub = item.subcategory?.title || "-";
        return `${sub}`;
      }).join(" | ");

        return [
          order.id,
          full_name,
          full_address,
          eircode,
          mobile,
          email,
          dob,
          products,
          category,
          subCategory,
          order.venue?.company?.title || "-",
          order.status,
          order.delivery_status,
          order?.payment?.total,
          order?.driver ? `${order.driver.user.first_name} ${order.driver.user.last_name}` : "-",
          moment(order.created_at).format("YYYY-MM-DD HH:mm")
        ].join(",");
      });

      const csvContent = headers.join("\n") + "\n" + csvRows.join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `sales_export_${Date.now()}.csv`;
      link.click();
  };

  exportXLSX = () => {
  const rows = this.state.data || [];
  if (rows.length === 0) return Notify.error("No orders to export");

  const sheetData = rows.map(order => {

    const address = order.data?.customer_address || {};

    const full_name = `${order.customer?.user?.first_name || ""} ${order.customer?.user?.last_name || ""}`;

    const full_address = 
      `${address.line_1 || ""} ${address.line_2 || ""} ${address.city || ""} ${address.state || ""}`.trim();

    const eircode = address.postal_code || "";
    const mobile = order.customer?.user?.phone_number || "";
    const email = order.customer?.user?.email || "";
    const dob = order.customer?.user?.date_of_birth || "";

    // Product Titles
    const products = order.data?.items?.map(entry => {
      const item = entry.item || {};
      return item.title || "-";
    }).join(" | ");

    // Parent Categories
    const category = order.data?.items?.map(entry => {
      const item = entry.item || {};
      return item.subcategory?.parent?.title || "-";
    }).join(" | ");

    // Subcategories
    const subCategory = order.data?.items?.map(entry => {
      const item = entry.item || {};
      return item.subcategory?.title || "-";
    }).join(" | ");

    return {
      "Order ID": order.id,
      "Name": full_name,
      "Full Address": full_address,
      "Eircode": eircode,
      "Mobile": mobile,
      "Email": email,
      "DOB": dob,
      "Product": products,
      "Category": category,
      "SubCategory": subCategory,
      "Vendor": order.venue?.company?.title || "-",
      "Status": order.status,
      "Delivery Status": order.delivery_status,
      "Total": order?.payment?.total,
      "Driver": order?.driver 
        ? `${order.driver.user.first_name} ${order.driver.user.last_name}`
        : "-",
      "Created At": moment(order.created_at).format("YYYY-MM-DD HH:mm"),
    };
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(sheetData);

  XLSX.utils.book_append_sheet(wb, ws, "Sales Data");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `sales_export_${Date.now()}.xlsx`);
};



  _renderDropdownContent(order) {
    const customer = order.customer;
    const items = order.data?.items || [];
    const address = order.data?.customer_address || {};

    if (!customer || items.length === 0) {
      return <div className="p-4 text-center text-red-500 bg-gray-50 border-t">Details unavailable for this order.</div>;
    }

    const renderDetail = (label, value) => (
      <div className="flex justify-between py-2 border-b border-gray-100 last:border-b-0">
        <span className="text-sm font-medium text-black">{label}</span>
        <span className="text-sm font-semibold text-gray-800">{value}</span>
      </div>
    );

    const customerName = General.toTitleCase(customer.user.first_name, customer.user.last_name);
    // Combine address parts, including Eircode
    const fullAddress = [address.line_1, address.city, address.eircode].filter(Boolean).join(', ');
    
    return (
      // Main container uses flex on large screens (lg:flex-row) and gap-8 for spacing
      <div className="flex flex-col lg:flex-row p-6 bg-gray-50 border-t border-indigo-400 gap-8 items-start">
        
        {/* Customer Details Section (w-5/12 for approximate col-5) */}
        <div className="w-full lg:w-5/12 p-6 bg-white rounded-xl shadow-lg border border-indigo-200">
          <h4 className="text-xl font-extrabold text-indigo-700 mb-4 border-b pb-2">
            Customer Details
          </h4>
          <div className="space-y-1">
            {renderDetail("Name: ", customerName)}
            {renderDetail("Full Address: ", fullAddress || '-')}
            {renderDetail("Eircode: ", address.eircode || '-')}
            {renderDetail("Mobile: ", customer.user.phone_number || '-')}
            {renderDetail("EMail Address: ", customer.user.email || '-')}
            {renderDetail("DOB: ", customer.user.date_of_birth)}
          </div>
        </div>

        {/* Product Details Section (w-7/12 for approximate col-7) */}
        <div className="w-full lg:w-7/12 p-6 bg-white rounded-xl shadow-lg border border-indigo-200 mt-7">
          <h4 className="text-xl font-extrabold text-indigo-700 mb-4 border-b pb-2">Order Items</h4>
          <div className="space-y-3 max-h-56 overflow-y-auto pr-2">
            {items.map((item, index) => {
                const itemDetails = item.item;
                const category = itemDetails?.subcategory?.parent?.title || 'N/A';
                const subcategory = itemDetails?.subcategory?.title || 'N/A';

                return (
                  <div key={index} className="p-3 bg-indigo-50 rounded-lg border border-indigo-200 hover:bg-indigo-100 transition duration-150">
                    <p className="font-bold text-base text-indigo-900">{itemDetails.title || 'Unknown Product'}</p>
                    <p className="text-xs text-gray-600 mt-0.5">
                      Category: <span className="font-semibold">{General.toTitleCase(category)}</span> / {General.toTitleCase(subcategory)}
                    </p>
                  </div>
                );
            })}
          </div>
        </div>
      </div>
    );
  }



  _cancelOrder(orderId) {
    this.setState({ isLoading: true });
    Backend.cancelOrder(orderId)
      .then((data) => {
        this.setState({ data, isLoading: false });
        window.location.reload();
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _getColumns() {
    return [
      {
        Header: () => <strong className="header__clr">ORDER NO.</strong>,
        id: "id",
        width: 95,
        Cell: (rowInfo) => {
          let order = rowInfo.original;
          let orderNumber = `${order.id}`;

          if (!orderNumber) {
            return "-";
          }

          return (
            <>
              <span className="text-dark-75 font-weight-bold line-height-sm">
                {orderNumber}
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">VENDOR</strong>,
        id: "address",
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let vendor = General.toTitleCase(order?.venue?.company?.title);

          let address = order?.venue?.address;

          if (!vendor || !address) {
            return "-";
          }

          return (
            <>
              <div className="ml-0 overflow-hidden">
                <div className="text-dark-75 font-weight-bold line-height-sm">
                  {vendor}
                </div>
                <a
                  href="javascript:;"
                  className="font-size-sm text-dark-50 text-hover-primary"
                >
                  {this._renderAddress(address)}
                </a>
              </div>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">STATUS</strong>,
        id: "status",
        width: 135,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let labelClass = "";
          let status = "";

          if (order.status === "accepted") {
            labelClass = "label-light-success";
            status = "Accepted";
          } else if (order.status === "pending") {
            labelClass = "label-dark-75";
            status = "Pending";
          } else if (order.status === "looking_for_driver") {
            labelClass = "label-light-info";
            status = "Looking For Driver";
          } else if (order.status === "rejected") {
            labelClass = "label-danger";
            status = "Rejected";
          }

          if (!status) {
            return "-";
          }

          return (
            <>
              <span className={`label ${labelClass} label-inline label-pill`}>
                {status}
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">DELIVERY STATUS</strong>,
        id: "delivery_status",
        width: 135,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let labelClass = "";
          let deliveryStatus = "";

          if (order.delivery_status === "delivered") {
            labelClass = "label-light-success";
            deliveryStatus = "Delivered";
          } else if (order.delivery_status === "pending") {
            labelClass = "label-light-info";
            deliveryStatus = "Pending";
          } else if (order.delivery_status === "failed") {
            labelClass = "label-dark-75";
            deliveryStatus = "Failed";
          } else if (order.delivery_status === "returned") {
            labelClass = "label-danger";
            deliveryStatus = "Returned";
          } else if (order.delivery_status === "out_for_delivery") {
            labelClass = "label-warning";
            deliveryStatus = "Out For Delivery";
          }

          if (!deliveryStatus) {
            return "-";
          }

          return (
            <>
              <span className={`label ${labelClass} label-inline label-pill`}>
                {deliveryStatus}
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">DRIVER</strong>,
        id: "user__first_name",
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let driver = "";

          if (order?.driver) {
            driver = `${General.toTitleCase(
              order?.driver?.user?.first_name
            )} ${General.toTitleCase(order?.driver?.user?.last_name)}`;
          } else {
            driver = "-";
          }

          return (
            <>
              <span>{driver}</span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">TOTAL</strong>,
        id: "price",
        width: 135,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let cost = order?.payment?.total;

          if (!cost) {
            return "-";
          }

          return (
            <>
              <span>{Currency.format(cost)}</span>
            </>
          );
        },
      },
      {
        Header: () => (
          <strong className="header__clr">ORDER DATE / TIME</strong>
        ),
        id: "created_at",
        Cell: (rowInfo) => {
          let order = rowInfo.original;
          let createdAt = `${moment(order?.created_at).format(
            "DD MMM YYYY - hh:mm A"
          )}`;

          if (!order?.created_at) {
            return "-";
          }

          return (
            <>
              <span className="text-dark-75 font-weight-bold line-height-sm">
                {createdAt}
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">ACTIONS</strong>,
        id: "id",
        width: 90,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let contactEmail = order?.venue?.contact_email;

          return (
            <>
              <span style={{ width: 130 }}>
                <a
                  href={`mailto: ${contactEmail}`}
                  target="_blank"
                  className="btn btn-icon btn-sm btn-pill btn-outline-primary ml-3"
                  data-toggle="popover"
                  data-content="Contact Vendor"
                  title="Email Vendor"
                >
                  <span className="svg-icon svg-icon-md">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect x={0} y={0} width={24} height={24} />
                        <path
                          d="M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                          fill="#FF5E8A"
                        />
                      </g>
                    </svg>
                  </span>
                </a>
                <a
                  href="javascript:;"
                  className="btn btn-icon btn-sm btn-pill btn-outline-primary ml-1"
                  data-toggle="popover"
                  data-content="Cancel Order"
                  title="Cancel Order"
                  onClick={() => this._cancelOrder(order?.id)}
                >
                  <span className="svg-icon svg-icon-md">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 48 48"
                      version="1.1"
                    >
                        <linearGradient id="wRKXFJsqHCxLE9yyOYHkza_fYgQxDaH069W_gr1" x1="9.858" x2="38.142" y1="9.858" y2="38.142" gradientUnits="userSpaceOnUse">
                          <stop offset="0" stop-color="#f44f5a"></stop>
                          <stop offset=".443" stop-color="#ee3d4a"></stop>
                          <stop offset="1" stop-color="#e52030"></stop>
                        </linearGradient>
                        <path fill="#73113b" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
                        <path d="M33.192,28.95L28.243,24l4.95-4.95c0.781-0.781,0.781-2.047,0-2.828l-1.414-1.414	c-0.781-0.781-2.047-0.781-2.828,0L24,19.757l-4.95-4.95c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414	c-0.781,0.781-0.781,2.047,0,2.828l4.95,4.95l-4.95,4.95c-0.781,0.781-0.781,2.047,0,2.828l1.414,1.414	c0.781,0.781,2.047,0.781,2.828,0l4.95-4.95l4.95,4.95c0.781,0.781,2.047,0.781,2.828,0l1.414-1.414	C33.973,30.997,33.973,29.731,33.192,28.95z" opacity=".05"></path>
                        <path d="M32.839,29.303L27.536,24l5.303-5.303c0.586-0.586,0.586-1.536,0-2.121l-1.414-1.414	c-0.586-0.586-1.536-0.586-2.121,0L24,20.464l-5.303-5.303c-0.586-0.586-1.536-0.586-2.121,0l-1.414,1.414	c-0.586,0.586-0.586,1.536,0,2.121L20.464,24l-5.303,5.303c-0.586,0.586-0.586,1.536,0,2.121l1.414,1.414	c0.586,0.586,1.536,0.586,2.121,0L24,27.536l5.303,5.303c0.586,0.586,1.536,0.586,2.121,0l1.414-1.414	C33.425,30.839,33.425,29.889,32.839,29.303z" opacity=".07"></path>
                        <path fill="#fff" d="M31.071,15.515l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414L18.343,32.485	c-0.391,0.391-1.024,0.391-1.414,0l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l14.142-14.142	C30.047,15.124,30.681,15.124,31.071,15.515z"></path>
                        <path fill="#fff" d="M32.485,31.071l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0L15.515,18.343	c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l14.142,14.142	C32.876,30.047,32.876,30.681,32.485,31.071z"></path>
                    </svg>
                  </span>
                </a>
              </span>
            </>
          );
        },
      },
    ];
  }

  render() {
    // const { isLoading } = this.state;
    const { isLoading, expandedRowId } = this.state;
    console.log("OrderHistoryTable expandedRowId: ", expandedRowId);
    const columns = this._getColumns();

    let tableProps = {};
    const extraParams = {};

    if (this.state.appliedStartDate) {
      extraParams.start_date = this.state.appliedStartDate;
    }

    if (this.state.appliedEndDate) {
      extraParams.end_date = this.state.appliedEndDate;
    }

    return (
      <>
        <div className="flex justify-between items-center mb-4" style={{backgroundColor:"white", padding:"10px"}}>
  
  {/* Date Range Inputs */}
      <h4 style={{padding:"7px 20px", marginBottom:"0px"}}>Export Sales Data</h4>
  <div className="flex row gap-2" style={{padding:"0px 20px"}}>
    <div className="col-4">
      <label className="block text-xs font-bold mr-4">Start Date</label>
      <input
        type="date"
        className="border rounded px-3 py-1" 
        value={this.state.startDate}
        onChange={(e) => this.setState({ startDate: e.target.value })}
      />
    </div>

    <div className="col-4">
      <label className="block text-xs font-bold mr-4">End Date</label>
      <input
        type="date"
        className="border rounded px-3 py-1"
        value={this.state.endDate}
        onChange={(e) => this.setState({ endDate: e.target.value })}
      />
    </div>

    <div className="col-4">
    {/* <button
      onClick={() => this.table.current.manualReload()}
      className="bg-600 text-black px-4 py-2 rounded mr-2"
      style={{background:"#73113b", border:"#73113b",color:"white", justifyContent:"end"}}
    >
      Apply
    </button> */}

    <button
      onClick={this._applyDateFilter}
      className="bg-600 text-black px-4 py-2 rounded mr-2"
      style={{
        background: "#73113b",
        border: "#73113b",
        color: "white",
        justifyContent: "end",
      }}
    >
      Apply
    </button>

      <button
      onClick={this.exportCSV}
      className="bg-green-600 text-white px-4 py-2 rounded mr-2"
      style={{background:"#73113b", border:"#73113b",color:"white", justifyContent:"end"}}
    >
      Export CSV
    </button>


      <button
      onClick={this.exportXLSX}
      className="bg-green-600 text-white px-4 py-2 rounded"
      style={{background:"#73113b", border:"#73113b",color:"white", justifyContent:"end"}}
    >
      Export XLSX
    </button>
    </div>
  </div>
</div>


        {/* <BaseTable
          {...tableProps}
          ref={this.table}
          title={this.props.title}
          loading={isLoading}
          endpoint={`${window.Api.Orders}`}
          extraParams={{
            start_date: this.state.startDate,
            end_date: this.state.endDate,
          }}
          noDataMessage={"No orders found"}
          onDataLoaded={(data) => {
            this.setState({ data });
          }}
          columns={columns}
          // filters={[STATUS_FILTERS, DELIVERY_STATUS_FILTERS]}
          filters={[STATUS_FILTERS, DELIVERY_STATUS_FILTERS]}
          showPagination={true}
          defaultSorted={[
            {
              id: "created_at",
              desc: true,
            },
          ]}
          // Passes mock data to BaseTable for demonstration since API endpoint is unavailable
          // data={this.state.data} 
          
          // Implementation of expandable row content: checks if the row is the expanded one and renders the custom content
          SubComponent={rowInfo => {
            if (rowInfo.original.id) {
              // The component needs to render outside the table cell wrapper
              return (
                <tr style={{margin:"auto"}}>
                    <td colSpan={this.table.current ? this.table.current.props.columns.length : 8} style={{ width: "1000px" }}>
                        {this._renderDropdownContent(rowInfo.original)}
                    </td>
                </tr>
              );
            }
            return null;
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                paddingLeft: 10,
                overflow: column.Header === "Actions" ? "visible" : "hidden",
              },
            };
          }}
        /> */}







<BaseTable
  {...tableProps}
  ref={this.table}
  title={this.props.title}
  loading={this.state.isLoading}
  endpoint={`${window.Api.Orders}`}
  // extraParams={{
  //   start_date: this.state.startDate || undefined,
  //   end_date: this.state.endDate || undefined,
  // }}

  extraParams={extraParams}
  noDataMessage={"No orders found"}
  onDataLoaded={(data) => {
    const rows = Array.isArray(data)
      ? data
      : Array.isArray(data?.results)
      ? data.results
      : Array.isArray(data?.data)
      ? data.data
      : [];

    this.setState({
      data: rows,
      isLoading: false,
    });
  }}
  columns={columns}
  filters={[STATUS_FILTERS, DELIVERY_STATUS_FILTERS]}
  showPagination={true}
  defaultSorted={[
    {
      id: "created_at",
      desc: true,
    },
  ]}
  SubComponent={(rowInfo) => {
    if (!rowInfo.original?.id) return null;

    return (
      <tr style={{ margin: "auto" }}>
        <td
          colSpan={
            this.table.current
              ? this.table.current.props.columns.length
              : 8
          }
          style={{ width: "1000px" }}
        >
          {this._renderDropdownContent(rowInfo.original)}
        </td>
      </tr>
    );
  }}
  getTdProps={(state, rowInfo, column) => {
    return {
      style: {
        paddingLeft: 10,
        overflow: column?.id === "id" ? "visible" : "hidden",
      },
    };
  }}
/>








      </>
    );
  }
}

OrdersHistoryTable.defaultProps = {
  title: "All Orders",
  showPagination: true,
  showPaginationTop: true,
  showPaginationBottom: true,
};

export default withRouter(OrdersHistoryTable);
